import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Layout, Header, SectionTitle } from '../../../../components';
import data from './data.json';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header site={data.site} slug={data.slug + '/develop/'} state="develop" title={data.title} mdxType="Header" />
    <Layout category="Overview" site={data.site} slug={data.slug + '/develop/'} state="develop" title={data.title} complete={true} mdxType="Layout">
  <div className="intro">
        <p>{`Elevation defines how content is presented along the z-axis of a design. All objects will exist within one of the panes, levels or nested distances described in the structure below. Different Shadow sizes communicate the distance between an elevated object and the pane behind it.`}</p>
  </div>
      <SectionTitle mdxType="SectionTitle">Structure</SectionTitle>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": "left"
            }}>{`Elevation`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Shadow Size`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Foundational Pane`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Used to present the main content of any design.`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`None`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Attention Pane`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Used to elevate important information a large distance above the foundational pane. Usually these are objects that require user action or attention, such as the `}<a href="https://currency-design-system.netlify.app/wt/patterns/modal/develop">{`Modal`}</a>{` pattern or `}<a href="https://currency-design-system.netlify.app/wt/components/notifications/develop">{`Notification`}</a>{` component.`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Large`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Interaction Level`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Used to elevate interactive elements above either the foundational or attention pane. Usually these are objects that appear when triggered by a user action, such as the dropdown of the `}<a href="https://currency-design-system.netlify.app/wt/components/select/develop">{`Select`}</a>{` component.`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Small`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Frame Level`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Used to elevate framing elements above either the foundational or attention pane. Usually these are objects that will remain fixed while the main content scrolls, such as the `}<a href="https://currency-design-system.netlify.app/wt/patterns/header/develop">{`Header`}</a>{` pattern.`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Medium`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": "left"
            }}>{`Artificial Elevation`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Used to create the appearance of visual depth within any level or pane without actually elevating any of the objects.`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`Small`}</td>
          </tr>
        </tbody>
      </table>
      <hr />
      <SectionTitle mdxType="SectionTitle">Design Environment</SectionTitle>
The shadow size associated with an elevated object will remain fixed, even if it scrolls over or spans across two or more surfaces behind it. Objects that are artificially elevated within any pane or level will stay flush with their parent container. This means they will scroll under any objects that their parent container scrolls under, no matter how elevated they appear to be.
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      